<template>
  <d-modal
    v-if="showModal"
    class="showModalVisitsInfo"
    style="background-color: rgba(0,0,0,0.8)!important;">
    <button
      @click.prevent.stop="closeModal"
      class="mr-1 new-close-button">
      <i class="material-icons close-icon">close</i>
    </button>
    <d-modal-header class="showModalVisits__header">
      <d-modal-title class="showModalVisits__header_title">
        <span><i class="material-icons">perm_contact_calendar</i> Rezerwacje</span> - szukaj terminu
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="showModalVisits__body">
      <d-form>
        <d-card class="mb-5">
          <d-tabs card class="showModalVisits">
            <d-tab>
              <validation-observer ref="visits-form" tag="form">
                <div
                  v-if="!reservation"
                  class="form-group">
                  <validation-provider
                    name="institution_id"
                    v-slot="{ errors }">
                    <label for="institution_id">Placówka: <span style="color: #c4183c">*</span></label>
                    <div :class="{ 'form-control': true, 'is-select': true }">
                      <v-select
                        :options="institutionsArr"
                        v-model="data.institution_id"
                        :reduce="institution => institution.id"
                        label="id">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.name }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
                <div
                  v-if="reservation"
                  class="form-group">
                  <validation-provider
                    name="institution_id"
                    v-slot="{ errors }">
                    <label for="institution_id">Placówka: <span style="color: #c4183c">*</span></label>
                    <div :class="{ 'form-control': true, 'is-select': true }">
                      <v-select
                        :disabled="reservation"
                        :options="institutionsArr"
                        v-model="reservationInstitution"
                        :reduce="institution => institution.id"
                        label="id">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.name }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
                <div
                  v-if="(data.institution_id && !reservationService && !reservationInstitution)"
                  class="form-group">
                  <validation-provider
                    name="service_id"
                    v-slot="{ errors }">
                    <label for="service_id">
                      Usługa: <span style="color: #c4183c">*</span>
                    </label>
                    <span
                      v-if="service.duration"
                      class="ml-3"
                      style="font-weight: 100; opacity: 0.6">Czas trwania usługi:
                      <span
                        style="font-weight: 600">{{service.duration.split(':')[0].length !== 1 ? (service.duration.split(':')[0] + ' minut') : (service.duration.split(':')[0] + ' h')}}
                      </span>
                    </span>
                    <filter-select
                      :key="keyServiceSelect"
                      v-model="data.service_id"
                      style="width: 100%;"
                      :endpoint-items="'/services/items?institution_id=' + data.institution_id"
                      :data-id="filters.service_id"
                      :duration="true"
                      :reduce="obj => obj.id"
                      :endpoint-item="'/services/item/'"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
                <div
                  v-if="(reservationInstitution && reservationService)"
                  class="form-group">
                  <validation-provider
                    name="service_id"
                    v-slot="{ errors }">
                    <label for="service_id">
                      Usługa: <span style="color: #c4183c">*</span>
                    </label>
                    <span
                      v-if="service.duration"
                      class="ml-3" style="font-weight: 100; opacity: 0.6">
                      Czas trwania usługi:
                      <span
                        style="font-weight: 600">{{service.duration.split(':')[0].length !== 1 ? (service.duration.split(':')[0] + ' minut') : (service.duration.split(':')[0] + ' h')}}
                      </span>
                    </span>
                    <v-select
                      :disabled="reservation"
                      :options="servicesArr"
                      v-model="reservationService"
                      :reduce="service => service.id"
                      label="id">
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
                <div
                  v-if="(data.institution_id || reservationInstitution) && ( data.service_id || reservationService)"
                  class="form-group">
                  <validation-provider
                    name="service_id"
                    v-slot="{ errors }">
                    <label for="service_id">Specjalista: <i class="material-icons info-expert-label" v-d-tooltip="'Jeśli chcesz aby system wyszukał wszystkich wolnych specjalistów dla usługi, zostaw to pole puste'">help</i> </label>
                    <filter-select
                      v-model="data.user_id"
                      style="width: 100%;"
                      :endpoint-items="'/users/items'"
                      :data-id="filters.service_id"
                      :reduce="obj => obj.id"
                      :endpoint-item="'/users/item/'"
                      :custom-params-filter="data.service_id"/>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
                <visits-date-of-the-visit
                  :key="keyVisitDate"
                  v-if="(data.institution_id || reservationInstitution) && (data.service_id || reservationService)"
                  :data-value="data"
                  :institution-id="reservation ? reservationInstitution :data.institution_id"
                  :medical-id="''"
                  :patient-id="reservation ? reservationPatient : data.patient_id"
                  :service-id="data.service_id ? data.service_id : reservationService"
                  :user-id="data.user_id"
                  :visit-date="data.visit_date"
                  :nav-bar-form="true"
                  :theme-buttons="'success'"
                  :modal-head-text="'Potwierdź rezerwacje'"
                  :close-modal="closeModal"
                  :single-shift="true"
                  :patient-popup="true"
                  :reservation-patient="reservation ? reservationPatientArr : ''"
                  :reservation-id="reservationId ? reservationId : ''"
                />
              </validation-observer>
              <div
                v-if="loaded"
                class="pb-3 pt-3 text-center">
                Trwa ładowanie danych&hellip;
              </div>
              <d-alert
                v-if="loadError"
                show
                theme="warning">
                Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
              </d-alert>
            </d-tab>
          </d-tabs>
        </d-card>
        <div class="visit-cancel">
          <d-button
            :theme="'secondary'"
            @click.prevent="closeModal"
            class="visit-cancel-button">
            Anuluj
          </d-button>
        </div>
      </d-form>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FilterSelect from '@/components/others/FilterSelect.vue';
import FormUtils from '@/utils/FormUtils.js';
import VisitsDateOfTheVisit from './VisitsDateOfTheVisit';
import PatientSuggestionFilter from '@/components/others/PatientSuggestionFilter';

export default {
  name: 'visits-form-popup',
  components: {
    VisitsDateOfTheVisit,
    FilterSelect,
    PatientSuggestionFilter
  },
  props: {
    closeModal: {
      required: true,
      type: Function
    },
    institutionsArr: {
      required: true,
      type: [Array, Object]
    },
    reservation: {
      type: Boolean
    },
    reservationId: {
      type: [String, Number]
    },
    reservationInstitution: {
      type: [String, Number]
    },
    reservationPatient: {
      type: [String, Number]
    },
    reservationService: {
      type: [String, Number]
    },
    servicesArr: {
      type: [Array, Object]
    },
    showModal: {
      required: true,
      type: [String, Boolean]
    }
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    },
  },
  watch: {
    'data.institution_id': function () {
      this.keyServiceSelect += 1;
      this.keyUserSelect += 1;
      this.componentKey += 1;
      this.keyVisitDate += 1;
    },
    'data.service_id': function (value) {
      this.getService(value);
      if (this.reservationPatient) {
        this.getReservationPatient();
      }
    },
    'data.patient_id': function (id) {
      if (!this.reservationPatient) {
        this.singlePatient(id);
      }
    },
    'reservationPatientArr': function () {
      this.data.pesel = this.reservationPatientArr.pesel;
      this.data.phone = this.reservationPatientArr.phone;
      this.data.last_name = this.reservationPatientArr.last_name;
      this.data.name = this.reservationPatientArr.name;
    },
    'showModal': function () {
      this.keyServiceSelect += 1;
      this.keyUserSelect += 1;
      this.componentKey += 1;
      this.keyVisitDate += 1;
    },
  },
  data () {
    return {
      componentKey: 0,
      data: {
        id: '',
        date_start: '',
        diagnosis: '',
        institution_id: '',
        interview: '',
        last_name: '',
        name: '',
        patient_id: '',
        pesel: '',
        phone: '',
        physical_examinations: '',
        procedures: '',
        recommendations: '',
        service_id: '',
        user_id: '',
        visit_date: '',
        waiting: 1
      },
      filters: {
        doc_id: 0,
        patient_id: 0,
        service_id: 0
      },
      keyServiceSelect: 0,
      keyUserSelect: 0,
      keyVisitDate: 0,
      loaded: false,
      loadError: false,
      reservationPatientArr: [],
      service: []
    }
  },
  mounted() {
    if (this.reservationPatient) {
      this.getReservationPatient(this.reservationPatient);
    }
  },
  methods: {
    getSinglePatient (patientID) {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/item/' + patientID,
        outputKey: 'patient',
        params: {
          pagination: false
        },
      });
    },
    getReservationPatient () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/item/' + this.reservationPatient,
        outputKey: 'reservationPatientArr',
        params: {
          pagination: false
        },
      });
    },
    singlePatient (id) {
      setTimeout(() => {
        if (this.getSinglePatient) {
          this.data.pesel = this.patient.pesel;
          this.data.phone = this.patient.phone;
          this.data.last_name = this.patient.last_name;
          this.data.name = this.patient.name;
        }
      }, 400);
      this.getSinglePatient(id)
    },
    getService () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/item/' + this.data.service_id,
        outputKey: 'service',
        params: {
          pagination: false
        },
      });
    }
  }
}
</script>

<style lang="scss">
  @import '../../../assets/scss/visits-form-popup.scss';
</style>
